import { Injectable } from '@angular/core';
import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/plugin/quarterOfYear';

import { DateInterface } from 'app/interfaces';

@Injectable()
export class PeriodService {
    static getLastMonth(): DateInterface {
        return this.createDateRange('month', dayjs().subtract(1, 'month'));
    }

    static getLastQuarter(): DateInterface {
        return this.createDateRange('quarter', dayjs().subtract(1, 'quarter'));
    }

    static getLastWeek(): DateInterface {
        return this.createDateRange('week', dayjs().subtract(1, 'week'));
    }

    static getLastYear(): DateInterface {
        return this.createDateRange('year', dayjs().subtract(1, 'year'));
    }

    static getThisMonth(): DateInterface {
        return this.createDateRange('month');
    }

    static getThisQuarter(): DateInterface {
        return this.createDateRange('quarter');
    }

    static getThisWeek(): DateInterface {
        return this.createDateRange('week');
    }

    static getThisYear(): DateInterface {
        return this.createDateRange('year');
    }

    static getToday(): DateInterface {
        return this.createDateRange('day');
    }

    private static createDateRange(unitOfTime, includedDate?: Dayjs): DateInterface {
        const date = {
            dateFrom: null,
            dateTo: null,
        };
        const dayjsDate = dayjs(includedDate);

        date.dateFrom = dayjsDate.startOf(unitOfTime).toISOString();

        date.dateTo = dayjsDate.endOf(unitOfTime).toISOString();
        return date;
    }
}
